export enum ScheduleCancelReason {
  OTHER_COMMITMENT = 'Tenho outro compromisso',
  NO_LONGER_NEEDED = 'Não preciso mais realizar a consulta',
  PREFER_NOT_TO_SAY = 'Prefiro não informar',
  OTHER = 'Outro'
}

export enum ScheduleCancelStatus {
  CANCELLING = 'CANCELLING',
  CHOOSING_REASON = 'CHOOSING_REASON',
  SENDING_REASON = 'SENDING_REASON',
  DONE = 'DONE',
  ERROR = 'ERROR'
}
